import React, {Component} from "react";
import Label from '../Label/Label';
import T from '../t/T';
import "./ComboBox2.scss";
import {default as _} from "../../../helpers/Translate"
import {connect} from "react-redux";

class ComboBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            language: this.props.language,
            inputValue: this.props.defaultValue ?? null
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.language !== this.props.language) {
            this.setState({language: this.props.language});
        }
    }

    onChangeHandler = (event) => {
        this.setState({
            inputValue: event.target.value
        }, () => {
            this.props.changeValueHandler(this.state.inputValue);
        });
    }

    render() {
        const {
            show = true,
            className = "",
            labelText = "",
            inlineLabel = true,
            removeColon = false,
            fieldName = "unknownField",
            comboboxValues = [],
            selectedItem = null,
            nonTransparent = false,
            fullWidth = false,
            disable = false,
            tabIndex
        } = this.props;

        return (show &&
            <div
                className={`${className} combobox-select ${fullWidth ? "full-width" : ""} ${inlineLabel ? "inline" : ""}`}>
                {
                    labelText.length > 0 && <Label labelText={labelText} removeColon={removeColon}/>
                }
                <select
                    className={`combobox-select-container ${fullWidth ? "full-width" : ""} ${nonTransparent ? "non-transparent" : "transparent"} ${disable ? "disable" : ""}`}
                    name={fieldName}
                    onChange={this.onChangeHandler}
                    value={selectedItem}
                    disabled={disable}
                    tabIndex={tabIndex}
                >
                    {
                        comboboxValues.map(item => <option key={item.id} value={item.value}>
                            {_.init3(item.rawText)} <T token={item.text}/>
                        </option>)
                    }
                </select>
            </div>
        )
    }
}

const mapStateToProps = state => {
  const language = state.LangReducer.language;
  return {language};
}
export default connect(mapStateToProps)(ComboBox);
